import { getTourStrings } from '../utils/tour-strings';
import type { TourItemKey } from './use-tour-store';
import { useTourStore } from './use-tour-store';

export const useTourStrings = (tourItemKey: TourItemKey) => {
  const appliedQuickAction = useTourStore((state) => state.appliedQuickAction);
  return getTourStrings(tourItemKey, appliedQuickAction);
};
